export default __webpack_public_path__ + "static/media/placeholder_dummy2016-schmuck01-de.2c86b203.png";